import {XauditModel} from '../xaudit.model';
import {PatientCaseViewDataModel} from './patient-case-view-data.model';

export class PatientCaseDataModel extends XauditModel {
  PatientCaseId: string;
  PatientId: string;
  LOCID: number;
  Description: string;
  TreatmentPlanningID: string;
  ReferringDoctorId: string;
  enumCaseStatusID: string;
  StatusOn: string;
  StatusBy: string;

  ParentPatientCaseId: string;
  ChildCases: PatientCaseViewDataModel[];
  DoctorId: string;
}
